import { render, staticRenderFns } from "./root.component.vue?vue&type=template&id=8dd4569c&"
import script from "./root.component.vue?vue&type=script&lang=ts&"
export * from "./root.component.vue?vue&type=script&lang=ts&"
import style0 from "./root.component.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports